<template>
  <div class="px-0 py-2">   
    <a v-b-toggle href="#sidebar-variant" @click.prevent>
      <b-img src="@/assets/hamburgermenu_96.png" class="img-responsive d-none d-sm-block"> </b-img>
      <b-img src="@/assets/hamburgermenu_48.png" class="img-responsive d-block d-sm-none"> </b-img>
    </a>
    
    
    <b-sidebar id="sidebar-variant"  bg-variant="light" text-variant="primary" sidebar-class="border-right" width="100px" right shadow>
      <div class="px-2 py-2">
        
<div>
  <b-button-group vertical>
    <b-button to="/">{{ $t('message.mainpage', { mainpage: 'Main' }) }}</b-button>
    <b-button to="/anounces">{{ $t('message.anounces', { anounces: 'Anounces' }) }}</b-button>
    <b-button to="/members">{{ $t('message.members', { members: 'Members' }) }}</b-button>
    <!-- b-button>Фото</b-button -->
    <b-button to="/videos">{{ $t('message.videos', { videos: 'Video' }) }}</b-button>
    <!-- b-button href="http://zillja.info">Пісні</b-button  -->
    <b-button to="/contacts">{{ $t('message.contacts', { contacts: 'Contacts' }) }}</b-button>
  </b-button-group>
</div>

      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
   // msg: Image
  }
}
</script>

